import { Form } from '@codehesion-za/headless';
import { FormikProps } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  donationSchema,
  PaymentAmountField,
  RecaptchaComponent,
} from '@project/components';
import { DonationFormValues, DonationProps } from './types';
import { ROBOT_CHECK_PASS } from '@project/helper';
import { useSessionStorage } from '@project/hooks';

export const PartnersIndividualSpecialDonationForm: React.FC<DonationProps> = ({
  donationTypeName,
}) => {
  const navigate = useNavigate();
  const [roboCheck, setRebotCheck] = useSessionStorage(ROBOT_CHECK_PASS, false);

  const onSubmitForm = (formData: DonationFormValues) => {
    navigate(
      `/payment?type=${formData.donationType}&amount=${formData.donationAmount}&currency=${formData.donationCurrency}&payment_type=donation&payment_method=${formData.paymentMethod}`,
    );
    return new Promise(() => null);
  };

  const FormComponents = ({
    isSubmitting,
    handleSubmit,
    values,
    setFieldError,
  }: FormikProps<DonationFormValues>) => {
    const handleOnSubmit = async () => {
      const MAX_AMOUNT = 999999.99;
      if (values.donationAmount > MAX_AMOUNT && values.paymentMethod === 'debit_credit') {
        setFieldError(
          'donationAmount',
          `Amount must be less than or equal to ${MAX_AMOUNT} ${values.donationCurrency}`,
        );
        return;
      }
      handleSubmit();
    };

    return (
      <div className="rounded-md bg-white px-10 py-20 shadow shadow-slate-300">
        <p className="text-xl">Select Donation Amount</p>
        <div className="border border-b" />
        <div className="py-20">
          <PaymentAmountField
            amountFieldName="donationAmount"
            currencyFieldName="donationCurrency"
            selectedCurrency={values.donationCurrency ?? ''}
            paymentMethod={values.paymentMethod ?? ''}
          />
        </div>
        <div className="border border-b" />
        <Button
          type="button"
          isLoading={isSubmitting}
          onClick={handleOnSubmit}
          style="bg-gold text-white py-3 px-16 rounded mt-10"
        >
          Continue
        </Button>
      </div>
    );
  };
  return roboCheck ? (
    <Form
      initialValues={{
        donationAmount: 1,
        donationCurrency: 'USD',
        donationType: donationTypeName,
        paymentMethod: 'debit_credit',
      }}
      onSubmitForm={onSubmitForm}
      onFailure={() => null}
      render={FormComponents}
      validationSchema={donationSchema}
    />
  ) : (
    <div className="my-2">
      <p>Verify you’re not a robot to continue</p>
      <RecaptchaComponent setRebotCheck={setRebotCheck} />
    </div>
  );
};
